export const HIRE_CLIPPERS_PATH = '/contratar-clipadores';

export type HireClippersOrigin = 'onboarding' | 'sidebar';

const ORIGINS: readonly string[] = ['onboarding', 'sidebar'];

/**
 * `source` of a lead sent from the app. It shows in the Origem column of
 * /admin/contatos, so sales knows the lead already has an account.
 */
export function resolveHireClippersSource(search: string): string {
  const origin = new URLSearchParams(search).get('origem');
  return origin && ORIGINS.includes(origin) ? `app:${origin}` : 'app';
}
